import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const GSTRegistrationServices = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        GST Registration Services
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        GST registration is a key requirement for individuals and entities in
        India engaged in the supply of goods or services, triggered by specific
        turnover thresholds or business activities, streamlining tax compliance
        under a unified system.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Registration Thresholds */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Registration Thresholds
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            In most Indian states, GST registration becomes mandatory when the
            annual supply of services or goods exceeds Rs. 20 lakhs, with a
            reduced threshold of Rs. 10 lakhs in special category states.
            Additionally, all e-commerce sellers must register irrespective of
            turnover.
          </p>

          {/* Filing Obligations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Filing Obligations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            All GST-registered taxpayers must file returns on the 10th, 15th, and
            20th of each month. Even during periods of no business activity, a
            NIL return is required on the GST portal to avoid penalties. GSTR-3B,
            due on the 20th, details monthly sales and purchases, while
            amendments to this form are not permitted.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Businesses with annual revenue over Rs. 1.5 crores file GSTR-1
            monthly by the 11th, while those below file quarterly by the 13th.
            Annual GST returns are mandatory by December 31st, with specific
            dates like January 20th, 2021, for December 2020 GSTR-3B.
          </p>

          {/* Compliance Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Composition Scheme:</strong> For turnovers up to Rs. 1.5
              crores, requiring CMP-08 quarterly by the 18th and GSTR-4 annually
              by April 30th.
            </li>
            <li>
              <strong>Staggered GSTR-3B:</strong> Deadlines vary—20th for
              turnovers above Rs. 5 crores, 22nd for Group A states, and 24th for
              Group B states with turnovers below Rs. 5 crores.
            </li>
          </ul>

          {/* Required Submissions */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Submissions
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Late filing incurs a Rs. 20 daily penalty per GSTR-3B and GSTR-1 (Rs.
            50 if sales are involved), plus 18% interest on late GST payments.
            Continuous non-filing for six months may lead to registration
            cancellation, barring re-registration until penalties are cleared.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            NIL returns are mandatory to avoid penalties, and composition scheme
            taxpayers must file additional returns until September of the
            succeeding year if opted mid-year.
          </p>

          {/* Final Considerations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Final Considerations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            GST registration services ensure compliance with India’s tax
            framework, with timely filing and accurate returns critical to
            avoiding penalties and maintaining business operations. Stay updated
            on due dates to manage obligations effectively.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GSTRegistrationServices;